import firebase from 'firebase/app'

import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";

// var config =  {
//   apiKey: "AIzaSyCTrQBkI0kve-7DoSWe23BopTgf5fGBJvo",
//   authDomain: "bid-project-cfae8.firebaseapp.com",
//   projectId: "bid-project-cfae8",
//   storageBucket: "bid-project-cfae8.appspot.com",
//   messagingSenderId: "718769442353",
//   appId: "1:718769442353:web:e6f10e4f1a99044eae8f10",
//   measurementId: "G-JMF4EPG2HF"
// };


var config = {
  apiKey: "AIzaSyBvfdCSL8JV8xouMfns1pHDLaOr29LoR0Y",
  authDomain: "livestock-dev-6f4fe.firebaseapp.com",
  projectId: "livestock-dev-6f4fe",
  storageBucket: "livestock-dev-6f4fe.appspot.com",
  messagingSenderId: "807884991928",
  appId: "1:807884991928:web:79dffaf59c282d6b6eb34d",
  measurementId: "G-K77MG4VLZ7"
};


firebase.initializeApp(config);
var auth = firebase.auth();
var storage = firebase.storage();
var db = firebase.firestore();

console.log("Firebase")

export {
  db,
  auth,
  storage
};